// **
//   All of the routes for SideNav in the DigitalPass are added here,
//   You can add a new route, customize the routes and delete the routes here.

//   Once you add a new route on this file it will be visible automatically on
//   the Sidenav.

//   For adding a new route you can follow the existing routes in the routes array.
//   1. The `type` key with the `collapse` value is used for a route.
//   2. The `type` key with the `title` value is used for a title inside the Sidenav.
//   3. The `type` key with the `divider` value is used for a divider between Sidenav items.
//   4. The `name` key is used for the name of the route on the Sidenav.
//   5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
//   6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
//   7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
//   inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
//   8. The `route` key is used to store the route location which is used for the react router.
//   9. The `href` key is used to store the external links location.
//   10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
//   10. The `component` key is used to store the component of its route.
// */
// DigitalPass components
//Admin Dashboard
import React, { lazy } from "react";

import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DvrIcon from "@mui/icons-material/Dvr";
import PaymentIcon from "@mui/icons-material/Payment";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AirplanemodeInactiveIcon from "@mui/icons-material/AirplanemodeInactive";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import LogoutIcon from "@mui/icons-material/Logout";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import Download from "@mui/icons-material/Download";
// import PaidIcon from "@mui/icons-material/Paid";
// import EditIcon from "@mui/icons-material/Edit";
import PostAddIcon from "@mui/icons-material/PostAdd";
import DashboardIcon from "@mui/icons-material/Dashboard";
import TimelineIcon from "@mui/icons-material/Timeline";
// Lazy loading components
const Logout = lazy(() => import("components/Auth/Logout"));
const DashboardLayout = lazy(() => import("layout/LayoutContainers/DashboardLayout"));
const CompanyList = lazy(() => import("components/Dashboard/CompanyList"));
const CompanyDetails = lazy(() => import("components/Dashboard/CompanyDetails"));
const ApplicationList = lazy(() => import("components/Dashboard/Applications/ApplicationList"));
const ViewApplication = lazy(() => import("components/Dashboard/Applications/ViewApplication"));
const ViewUser = lazy(() => import("components/Dashboard/Users/ViewUser"));
const UserList = lazy(() => import("components/Dashboard/Users/UserList"));
const TransactionList = lazy(() => import("components/Dashboard/Transactions/TransactionList"));
const DigitalPassList = lazy(() => import("components/Dashboard/Digital Passes/DigitalPassList"));
const ViewDigitalPass = lazy(() => import("components/Dashboard/Digital Passes/ViewDigitalPass"));
const DigitalPasses = lazy(() => import("components/Dashboard/Download/DigitalPasses"));
const DownloadSikaps = lazy(() => import("components/Dashboard/Download/SikapsDownload"));
const Applications = lazy(() => import("components/Dashboard/Download/Applications"));
const DPPDashboard = lazy(() => import("components/Dashboard/DPP Dashboard/DPPDashboard"));
const StickerDownload = lazy(() =>
  import("components/Dashboard/Download/StickerDownload")
);
const VehicleDownload = lazy(() =>
  import("components/Dashboard/Download/VehicleDownload")
);
const AllEvents = lazy(() => import("components/Dashboard/MAGEvents/Allevents"));
const Users = lazy(() => import("components/Dashboard/Download/Users"));
const Companies = lazy(() => import("components/Dashboard/Download/Companies"));
const Transactions = lazy(() => import("components/Dashboard/Download/Transactions"));
const CompanyManagement = lazy(() => import("components/Dashboard/CompanyManagement"));
const UserManagement = lazy(() => import("components/Dashboard/UserManagement"));
const NewSikap = lazy(() => import("components/Dashboard/Sikaps/New Sikap"));
const SikapList = lazy(() => import("components/Dashboard/Sikaps/All Sikaps/SikapsList"));
const SystemAdminstrator = lazy (() => import("components/Dashboard/Adminstrator/AddNewAdmin") )
const AllSystemAdminstrators = lazy (() => import("components/Dashboard/Adminstrator/AllAdminstrators/adminList") )
const ViewSystemUser = lazy (() => import("components/Dashboard/Adminstrator/AllAdminstrators/viewAdmin") )
const ViewSikap = lazy(() => import("components/Dashboard/Sikaps/View Sikap"));
const SikapTransactionList = lazy(() =>
  import("components/Dashboard/Sikaps/SikapTransactions/SikapsTransactionList")
);
const MAGEvents = lazy(() => import("components/Dashboard/Download/MAGEvents"));
const VehicleList = lazy(() =>
  import("components/Dashboard/Vehicles/VehicleList")
);
const ViewVehicle = lazy(() =>
  import("components/Dashboard/Vehicles/ViewVehicle")
);
const ViewSticker = lazy(() =>
  import("components/Dashboard/Stickers/Sticker/ViewSticker")
);
const StickerList = lazy(() =>
  import("components/Dashboard/Stickers/StickerList/StickerList")
);
const VehicleTransactionList = lazy(() =>
  import(
    "components/Dashboard/Vehicles/VehicleTransactions/VehicleTransactionList"
  )
);

let superAdminRoutes = [
  {
    type: "title",
    title: "Dashboard",
    key: "dashboard-pages",
  },
  {
    type: "collapse",
    name: "DPP Dashboard",
    key: "/dashboard/penangport",
    route: "/dashboard/penangport",
    component: (
      <DashboardLayout>
        <DPPDashboard />
      </DashboardLayout>
    ),
    icon: <DashboardIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "title",
    title: "Download",
    key: "download-pages",
  },
  {
    type: "collapse",
    name: "Download",
    key: "download",
    icon: <Download />,
    collapse: [
      {
        type: "collapse",
        name: "DigitalPasses",
        key: "/download/digitalpasses",
        route: "/download/digitalpasses",
        component: (
          <DashboardLayout>
            <DigitalPasses />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Applications",
        key: "/download/applications",
        route: "/download/applications",
        component: (
          <DashboardLayout>
            <Applications />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Users",
        key: "/download/users",
        route: "/download/users",
        component: (
          <DashboardLayout>
            <Users />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Companies",
        key: "/download/companies",
        route: "/download/companies",
        component: (
          <DashboardLayout>
            <Companies />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "MAGEvents",
        key: "/download/magevents",
        route: "/download/magevents",
        component: (
          <DashboardLayout>
            <MAGEvents />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Transactions",
        key: "/download/transactions",
        route: "/download/transactions",
        component: (
          <DashboardLayout>
            <Transactions />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Sikaps",
        key: "/download/sikaps",
        route: "/download/sikaps",
        component: (
          <DashboardLayout>
            <DownloadSikaps />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Stickers",
        key: "/download/stickers",
        route: "/download/stickers",
        component: (
          <DashboardLayout>
            <StickerDownload />
          </DashboardLayout>
        ),
        icon: <Download />,
        noCollapse: true,
        status: 2,
      },
      {
        type: "collapse",
        name: "Vehicle",
        key: "/download/vehicles",
        route: "/download/vehicles",
        component: (
          <DashboardLayout>
            <VehicleDownload />
          </DashboardLayout>
        ),
      },
    ],
  },

  {
    type: "title",
    title: "DigitalPortpass",
    key: "digitalpass-pages",
  },
  {
    type: "collapse",
    name: "Active Portpass",
    key: "/digitalpass/active",
    route: "/digitalpass/active",
    component: (
      <DashboardLayout>
        <DigitalPassList key="active" type="active" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeActiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Inactive Portpass",
    key: "/digitalpass/inactive",
    route: "/digitalpass/inactive",
    component: (
      <DashboardLayout>
        <DigitalPassList key="inactive" type="inactive" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeInactiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "All Portpass",
    key: "/digitalpass/all",
    route: "/digitalpass/all",
    component: (
      <DashboardLayout>
        <DigitalPassList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/digitalpass/:_id",
    key: "/digitalpass/:_id",
    component: (
      <DashboardLayout>
        <ViewDigitalPass />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-11" },

  {
    type: "title",
    title: "Applications",
    key: "passes-pages",
  },
  {
    type: "collapse",
    name: "New Applications",
    key: "/applications/new",
    route: "/applications/new",
    component: (
      <DashboardLayout>
        <ApplicationList key="new" type="new" />
      </DashboardLayout>
    ),
    icon: <CircleNotificationsIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Approved Applications",
    key: "/applications/approved",
    route: "/applications/approved",
    component: (
      <DashboardLayout>
        <ApplicationList key="approve" type="approve" />
      </DashboardLayout>
    ),
    icon: <CheckCircleOutlineIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Rejected Applications",
    key: "/applications/rejected",
    route: "/applications/rejected",
    component: (
      <DashboardLayout>
        <ApplicationList key="rejected" type="rejected" />
      </DashboardLayout>
    ),
    icon: <GppMaybeIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Completed Applications",
    key: "/applications/completed",
    route: "/applications/completed",
    component: (
      <DashboardLayout>
        <ApplicationList key="completed" type="completed" />
      </DashboardLayout>
    ),
    icon: <DoneAllIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "All Applications",
    key: "/applications/all",
    route: "/applications/all",
    component: (
      <DashboardLayout>
        <ApplicationList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
  },
  {
    type: null,
    route: "/applications/:id",
    key: "/applications/:id",
    component: (
      <DashboardLayout>
        <ViewApplication />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-10" },

  {
    type: "title",
    title: "Trainings",
    key: "training-pages",
  },
  {
    type: "collapse",
    name: "Passed Tests",
    key: "/applications/passedtests",
    route: "/applications/passedtests",
    component: (
      <DashboardLayout>
        <ApplicationList key="passedtests" type="passedtests" />
      </DashboardLayout>
    ),
    icon: <DoneAllIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Failed Tests",
    key: "/applications/failedtests",
    route: "/applications/failedtests",
    component: (
      <DashboardLayout>
        <ApplicationList key="failedtests" type="failedtests" />
      </DashboardLayout>
    ),
    icon: <GppMaybeIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-4" },

  {
    type: "title",
    title: "Companies",
    key: "company-pages",
  },
  {
    type: "collapse",
    route: "/companies/new",
    name: "New Companies",
    key: "/companies/new",
    icon: <AddBusinessIcon />,
    component: (
      <DashboardLayout>
        <CompanyList key="new" type="new" />
      </DashboardLayout>
    ),
    noCollapse: true,
  },
  {
    type: "collapse",
    route: "/companies/all",
    name: "All Companies",
    key: "/companies/all",
    icon: <DvrIcon />,
    component: (
      <DashboardLayout>
        <CompanyList key="all" type="all" />
      </DashboardLayout>
    ),
    noCollapse: true,
  },
  {
    type: null,
    route: "/company/:id",
    key: "/company/:id",
    component: (
      <DashboardLayout>
        <CompanyDetails />
      </DashboardLayout>
    ),
  },
  {
    type: "redirect",
    from: "/companies/*",
    to: "/companies/all",
    key: "/companies/all",
  },
  { type: "divider", key: "divider-6", status: 2 },
  { type: "title", title: "User", key: "user-pages", status: 2 },
  {
    type: "collapse",
    route: "/users/all",
    name: "All Users",
    key: "/users/all",
    icon: <DvrIcon />,
    component: (
      <DashboardLayout>
        <UserList />
      </DashboardLayout>
    ),
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/user/:id",
    key: "/user/:id",
    component: (
      <DashboardLayout>
        <ViewUser />
      </DashboardLayout>
    ),
    status: 2,
  },
  { type: "divider", key: "divider-9", status: 2 },
  { type: "title", title: "Vehicles", key: "vehicles-pages", status: 2 },
  {
    type: "collapse",
    name: "New Vehicles",
    key: "/vehicles/new",
    route: "/vehicles/new",
    component: (
      <DashboardLayout>
        <VehicleList key="new" type="new" />
      </DashboardLayout>
    ),
    icon: <CircleNotificationsIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Approved Vehicles",
    key: "/vehicles/approved",
    route: "/vehicles/approved",
    component: (
      <DashboardLayout>
        <VehicleList key="approved" type="approved" />
      </DashboardLayout>
    ),
    icon: <CheckCircleOutlineIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Rejected Vehicles",
    key: "/vehicles/rejected",
    route: "/vehicles/rejected",
    component: (
      <DashboardLayout>
        <VehicleList key="rejected" type="rejected" />
      </DashboardLayout>
    ),
    icon: <GppMaybeIcon sx={{ color: "error.main" }} />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Completed Vehicles",
    key: "/vehicles/completed",
    route: "/vehicles/completed",
    component: (
      <DashboardLayout>
        <VehicleList key="completed" type="completed" />
      </DashboardLayout>
    ),
    icon: <DoneAllIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "All Vehicles",
    key: "/vehicles/all",
    route: "/vehicles/all",
    component: (
      <DashboardLayout>
        <VehicleList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/vehicle/:id",
    key: "/vehicle/:id",
    component: (
      <DashboardLayout>
        <ViewVehicle />
      </DashboardLayout>
    ),
    status: 2,
  },
  {
    type: null,
    route: "/vehicle/sticker/:id",
    key: "/vehicle/sticker/:id",
    component: (
      <DashboardLayout>
        <ViewSticker />
      </DashboardLayout>
    ),
    status: 2,
  },
  { type: "divider", key: "divider-15" },
  {
    type: "title",
    title: "Stickers",
    key: "sticker-pages",
  },
  {
    type: "collapse",
    name: "Active Stickers",
    key: "/stickers/active",
    route: "/stickers/active",
    component: (
      <DashboardLayout>
        <StickerList key="active" type="active" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeActiveIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "Inactive Stickers",
    key: "/stickers/inactive",
    route: "/stickers/inactive",
    component: (
      <DashboardLayout>
        <StickerList key="inactive" type="inactive" />
      </DashboardLayout>
    ),
    icon: <AirplanemodeInactiveIcon sx={{ color: "warning.main" }} />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "All Stickers",
    key: "/stickers/all",
    route: "/stickers/all",
    component: (
      <DashboardLayout>
        <StickerList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <FormatListBulletedIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/vehicle/sticker/:id",
    key: "/vehicle/sticker/:id",
    component: (
      <DashboardLayout>
        <ViewSticker />
      </DashboardLayout>
    ),
    status: 2,
  },

  { type: "divider", key: "divider-50" },
  {
    type: "title",
    title: "Sikaps",
    key: "sikaps-pages",
  },
  {
    type: "collapse",
    name: "Add New Sikap",
    key: "/sikaps/add",
    route: "/sikaps/add",
    component: (
      <DashboardLayout>
        <NewSikap />
      </DashboardLayout>
    ),

    noCollapse: true,
    icon: <PostAddIcon />,
  },
  {
    type: "collapse",
    name: "All Sikaps",
    key: "/sikaps/all",
    route: "/sikaps/all",
    component: (
      <DashboardLayout>
        <SikapList key="all" type="all" />
      </DashboardLayout>
    ),

    noCollapse: true,
    icon: <FormatListBulletedIcon />,
  },
  {
    type: null,
    route: "/sikaps/view/:id",
    key: "/sikaps/view/:id",
    component: (
      <DashboardLayout>
        <ViewSikap />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-500" },
  {
    type: "title",
    title: "MAG Events",
    key: "events-pages",
  },
  {
    type: "collapse",
    name: "Penang Port MAGEvents",
    key: "/events/penangport/all",
    route: "/events/penangport/all",
    component: (
      <DashboardLayout>
        <AllEvents key="penangport" type="penangport" />
      </DashboardLayout>
    ),
    icon: <TimelineIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-5" },

  {
    type: "title",
    title: "Transactions",
    key: "transaction-pages",
  },
  {
    type: "collapse",
    name: "Digital Portpass Transactions",
    key: "/digitalpasses/transaction/all",
    route: "/digitalpasses/transaction/all",
    component: (
      <DashboardLayout>
        <TransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Vehicle Transactions",
    key: "/vehicle/transaction/all",
    route: "/vehicle/transaction/all",
    component: (
      <DashboardLayout>
        <VehicleTransactionList key="all" type="all" />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Sikaps Transactions",
    key: "/sikaps/transaction/all",
    route: "/sikaps/transaction/all",
    component: (
      <DashboardLayout>
        <SikapTransactionList key="all" type="all" />
      </DashboardLayout>
    ),

    icon: <PaymentIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-1" },
  {
    type: "title",
    title: "Management",
    key: "management-pages",
  },
  {
    type: "collapse",
    name: "Company Management",
    key: "/management/company",
    route: "/management/company",
    component: (
      <DashboardLayout>
        <CompanyManagement />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "User Management",
    key: "/management/user",
    route: "/management/user",
    component: (
      <DashboardLayout>
        <UserManagement />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-60" },
  {
    type: "title",
    title: "System Management",
    key: "management-pages-2",
  },
  {
    type: "collapse",
    name: "Add System User",
    key: "/system/management/add",
    route: "/system/management/add",
    component: (
      <DashboardLayout>
        <SystemAdminstrator />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: "collapse",
    name: "All System Adminstrators",
    key: "/system/management/all",
    route: "/system/management/all",
    component: (
      <DashboardLayout>
        <AllSystemAdminstrators />
      </DashboardLayout>
    ),
    icon: <PaymentIcon />,
    noCollapse: true,
    status: 2,
  },
  {
    type: null,
    route: "/system/management/user/:id",
    key: "/system/management/user/:id",
    component: (
      <DashboardLayout>
        <ViewSystemUser />
      </DashboardLayout>
    ),
    status: 2,
  },
  { type: "divider", key: "divider-7" },
  { type: "title", title: "Profile", key: "profile-pages" },
  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "home",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-3" },
];
export default superAdminRoutes;
